import { useCallback, useEffect, useRef, useState } from "react";
import { useNFTS } from "../../hooks/useNFTS";
import { BigNumber, ethers } from 'ethers';
import config from '../../config';
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { IAccount } from '../../types';
import { useAccount } from '../../hooks/useAccount';
import { setToast } from '../../store/actions/Toast';
import { Pot } from '../atoms';
import { CircularProgress } from '@mui/material';

const DepositCard = (props: any) => {
  const myNFTs = useNFTS();
  let _account: IAccount = useAccount();
  const dispatch: Dispatch<any> = useDispatch();

  const { ...account } = _account as any;
  const [balance, setBalance] = useState('0');
  const [balanceDeposited, setBalanceDeposited] = useState(0);
  const [earned, setEarned] = useState(0);
  const [toDeposit, setToDeposit] = useState('0');
  const [loadingDeposit, setLoadingDeposit] = useState(false);
  const [loadingClaim, setLoadingClaim] = useState(false);

  const init = async () => {
    try {
      if (account.account) {
        getMonsterBalance()
      }
    } catch (err: any) {
      console.log(err)
    }
  };
  const getMonsterBalance = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();
    const tokenContract = new ethers.Contract(
      config.TokenAddress,
      config.MTokenAbi,
      signer !== null ? signer : provider
    );
    const referralMintContract = new ethers.Contract(
      config.ReferralMintAddress,
      config.ReferralMintAbi,
      signer !== null ? signer : provider
    );
    try {
      const balance = await tokenContract.balanceOf(account.account.address);
      setBalance(ethers.utils.formatEther(balance.toString()))
      const balanceDeposited = await referralMintContract.tokensDepoisted(account.account.address)
      setBalanceDeposited(Number(ethers.utils.formatEther(balanceDeposited.toString())))
      if (Number(ethers.utils.formatEther(balanceDeposited.toString())) > 0) {
        const earned = await referralMintContract.earned(account.account.address)
        setEarned(Number((ethers.utils.formatEther(earned.toString()))))
      }

    } catch (ex) {
      console.log(ex)
    }
  }

  const deposit = async () => {
    setLoadingDeposit(true)
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();

    const mTokenContract = new ethers.Contract(
      config.TokenAddress,
      config.MTokenAbi,
      signer !== null ? signer : provider
    );
    const referralMintContract = new ethers.Contract(
      config.ReferralMintAddress,
      config.ReferralMintAbi,
      signer !== null ? signer : provider
    );

    try {
      //need to approve mtoken just one time
      const erc20Allowance = await mTokenContract.allowance(
        account.account.address,
        config.ReferralMintAddress
      );
      if (parseInt(ethers.utils.formatEther(erc20Allowance)) < 1) {
        const approveTx = await mTokenContract.approve(
          config.ReferralMintAddress,
          '100000000000000000000000',
          { gasLimit: 500000 }
        );
        const receipt = await approveTx.wait();
        if (receipt) {
          dispatch(
            setToast({
              visible: true,
              message: `Monster Token usage approved`,
              type: 'success',
            })
          );
        }
      }
      const deposit = await referralMintContract.deposit(ethers.utils.parseEther(toDeposit.toString()))
      if (deposit) {
        listenDeposit()
        dispatch(
          setToast({
            visible: true,
            message: `$MONSTER deposited`,
            type: 'success',
          })
        );
      }
      setLoadingDeposit(false)

    } catch (err: any) {
      setLoadingDeposit(false)
      dispatch(
        setToast({
          visible: true,
          message: `An error has ocurred`,
          type: 'error',
        })
      );
    }

  };
  const claim = async () => {
    setLoadingClaim(true)

    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();
    const referralMintContract = new ethers.Contract(
      config.ReferralMintAddress,
      config.ReferralMintAbi,
      signer !== null ? signer : provider
    );
    try {
      const claim = await referralMintContract.claim();
      if (claim) {
        listenClaim()
        dispatch(
          setToast({
            visible: true,
            message: `ETH was claimed`,
            type: 'success',
          })
        );
      }
      setLoadingDeposit(false)

    } catch (error: any) {
      setLoadingDeposit(false)
      dispatch(
        setToast({
          visible: true,
          message: `An error has ocurred`,
          type: 'error',
        })
      );
      console.log(error)
    }

  };
  const listenDeposit = () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();
    const referralMintContract = new ethers.Contract(
      config.ReferralMintAddress,
      config.ReferralMintAbi,
      signer !== null ? signer : provider
    );
    try {
      console.log("Listener started");
      // const provider = new ethers.providers.JsonRpcProvider(
      //   "https://rinkeby.infura.io/v3/799ad57d4067419db57bf9592b471301"
      // );

      const filter = referralMintContract.filters.Deposited();

      console.log("watching for events...");
      // Receive an event when that filter occurs
      referralMintContract.on(filter, async (from, to, amount, event, unknow) => {
        console.log("event received");
        getMonsterBalance()
      });
    } catch (err) {
      console.log(err);
    }
  }
  const listenClaim = () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    const signer = provider.getSigner();
    const referralMintContract = new ethers.Contract(
      config.ReferralMintAddress,
      config.ReferralMintAbi,
      signer !== null ? signer : provider
    );
    try {
      console.log("Listener started");
      // const provider = new ethers.providers.JsonRpcProvider(
      //   "https://rinkeby.infura.io/v3/799ad57d4067419db57bf9592b471301"
      // );

      const filter = referralMintContract.filters.Claimed();

      console.log("watching for events...");
      // Receive an event when that filter occurs
      referralMintContract.on(filter, async (from, to, amount, event, unknow) => {
        getMonsterBalance()
      });
    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {
    init();
  }, [account]);

  return (
    <div className="deposit-card">
      <div className="deposit-header">
        <h1>Deposit {props.nameToken}</h1>
        <p><span>Important: </span>You can only deposit once per address</p>
      </div>
      <div className="content">
        <div className='left'>
          <div className='header'>
            {balanceDeposited > 0 ?
              <p><span>Deposited balance:</span> {balanceDeposited.toLocaleString("en-US", { minimumFractionDigits: 4 })} {props.nameToken}</p>
              :
              <p><span>Your balance: </span>
                {Math.floor(parseFloat(balance) * 10000) / 10000} {props.nameToken}
              </p>
            }
          </div>
          <div className='body'>
            {balanceDeposited === 0 &&
              <>
                {loadingDeposit ?
                  <CircularProgress />
                  : <>
                    <div className='input'>
                      <input
                        type="number"
                        value={toDeposit}
                        max={balance}
                        onChange={(e: any) => setToDeposit(e.target.value <= parseFloat(balance) && e.target.value >= 0 ? e.target.value : balance)}
                      />
                      <button
                        onClick={() => setToDeposit(balance)}>
                        Max
                      </button>
                    </div>
                    <button
                      disabled={parseFloat(toDeposit) <= 0}
                      onClick={deposit}
                    >
                      Deposit
                    </button>
                  </>}
              </>}
          </div>
        </div>
        <div className='right'>
          {balanceDeposited > 0 &&
            <>
              <div className='header'>
                <p><span>Reward:</span> </p>
                <p>{earned.toLocaleString("en-US", { minimumFractionDigits: 4 })} ETH</p>
                {loadingClaim ?
                  <CircularProgress />
                  : <button
                    disabled={earned <= 0}
                    onClick={claim}
                  >
                    Claim
                  </button>}
              </div>
              <div className='body'>

              </div>
            </>}
        </div>
      </div>

    </div>
  );
};

export default DepositCard;
